import { Component, OnInit, ViewChild, AfterViewInit, Input,  Output,EventEmitter } from '@angular/core';
import { Modal } from 'ngx-modal';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';


@Component({
    selector: 'account-restriction-popup',
    templateUrl: '../templates/template1/views/account-restriction-popup.component.html',
    styleUrls: [
        //  "../templates/template1/themes/default/css/search.less"
    ]
})

export class AccountRestrictionPopup implements OnInit {
    private eventsSubscription: Subscription;

    @Input() memberDetails: Observable<void>;
    @ViewChild('memberRestrictionModal') memberRestrictionModal: Modal;
    @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
    constructor() { }

    ngOnInit(): void {
        this.memberRestrictionModal.open();
    }

    closememberRestrictionModal(){
        this.closeModal.emit(false);
        this.memberRestrictionModal.close();
    }
    
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/account-restriction-popup.component.ts